import {
  ElementClientRect,
  ElementGraphicRect as ElementBillableRect,
  ElementPrintAreaRect,
} from '../../models/common/elementClientRect'
import {getRectEndValues} from './elementClientRect'
import {ProductPricing} from '../../models/dto/common/productPricing'

export const calculatePrice = (
  printArea: ElementPrintAreaRect | null,
  printAreaNativeWidth: number,
  printAreaNativeHeight: number,
  billables: ElementBillableRect[],
  pricing: ProductPricing,
  selectedPageIndex: number | undefined,
  calendar: boolean,
  isBack = false,
  isThereFrontContent = false,
  forceBack = false,
): number | null => {
  if (billables.length === 0) {
    return null // No content yet
  }
  if (!printArea) {
    return null
  }

  const hasGraphic: boolean = billables.reduce<boolean>(
    (hasGraph, current) => hasGraph || current.type === 'graphic',
    false,
  )

  const mergedBillables: ElementClientRect | null =
    billables.reduce<ElementClientRect | null>(
      (merged, current) => getRectEndValues(merged, current),
      null,
    )
  if (!mergedBillables) {
    // Type safety
    return null
  }

  mergedBillables.x1 = Math.max(printArea.x1, mergedBillables.x1)
  mergedBillables.x2 = Math.min(printArea.x2, mergedBillables.x2)
  mergedBillables.y1 = Math.max(printArea.y1, mergedBillables.y1)
  mergedBillables.y2 = Math.min(printArea.y2, mergedBillables.y2)

  // Real billable size
  const billableWidth = mergedBillables.x2 - mergedBillables.x1
  const billableHeight = mergedBillables.y2 - mergedBillables.y1
  const printAreaWidth = printArea.x2 - printArea.x1
  const printAreaHeight = printArea.y2 - printArea.y1
  const realWidth = (printAreaNativeWidth * billableWidth) / printAreaWidth
  const realHeight = (printAreaNativeHeight * billableHeight) / printAreaHeight

  const billablesLargeSide = Math.max(realWidth, realHeight)
  const billablesSmallSide = Math.min(realWidth, realHeight)

  const printAreaSzivoldalLargeSide = Math.max(
    pricing.szivoldalWidthMm,
    pricing.szivoldalHeightMm,
  )
  const printAreaSzivoldalSmallSide = Math.min(
    pricing.szivoldalWidthMm,
    pricing.szivoldalHeightMm,
  )
  const editableArea = calendar
    ? pricing.editableArea
    : selectedPageIndex === 0
    ? pricing.editableArea
    : pricing.editableAreaBack
  console.log('selectedPageIndex', selectedPageIndex)
  console.log('isBack', isBack)
  console.log('isThereFrontContent', isThereFrontContent)
  console.log('billables', billables)
  switch (editableArea) {
    case 'szivoldal': {
      if (hasGraphic) {
        return isBack &&
          isThereFrontContent &&
          pricing.szivoldalGraphicPriceBack > 0
          ? pricing.szivoldalGraphicPriceBack
          : pricing.szivoldalGraphicPrice
      } else {
        return isBack &&
          isThereFrontContent &&
          pricing.szivoldalCaptionPriceBack > 0
          ? pricing.szivoldalCaptionPriceBack
          : pricing.szivoldalCaptionPrice
      }
    }
    case 'a4': {
      if (
        billablesLargeSide <= printAreaSzivoldalLargeSide &&
        billablesSmallSide <= printAreaSzivoldalSmallSide
      ) {
        if (hasGraphic) {
          return isBack &&
            isThereFrontContent &&
            pricing.szivoldalGraphicPriceBack > 0
            ? pricing.szivoldalGraphicPriceBack
            : pricing.szivoldalGraphicPrice
        } else {
          return isBack &&
            isThereFrontContent &&
            pricing.szivoldalCaptionPriceBack > 0
            ? pricing.szivoldalCaptionPriceBack
            : pricing.szivoldalCaptionPrice
        }
      } else {
        if (hasGraphic) {
          return isBack && isThereFrontContent && pricing.a4GraphicPriceBack > 0
            ? pricing.a4CaptionPriceBack
            : pricing.a4GraphicPrice
        } else {
          return isBack && isThereFrontContent && pricing.a4CaptionPriceBack > 0
            ? pricing.a4CaptionPriceBack
            : pricing.a4CaptionPrice
        }
      }
    }
    case 'a3': {
      const printAreaA4LargeSide = Math.max(
        pricing.a4WidthMm,
        pricing.a4HeightMm,
      )
      const printAreaA4SmallSide = Math.min(
        pricing.a4WidthMm,
        pricing.a4HeightMm,
      )
      if (
        billablesLargeSide <= printAreaSzivoldalLargeSide &&
        billablesSmallSide <= printAreaSzivoldalSmallSide
      ) {
        if (hasGraphic) {
          return isBack &&
            isThereFrontContent &&
            pricing.szivoldalGraphicPriceBack > 0
            ? pricing.szivoldalGraphicPriceBack
            : pricing.szivoldalGraphicPrice
        } else {
          return isBack &&
            isThereFrontContent &&
            pricing.szivoldalCaptionPriceBack > 0
            ? pricing.szivoldalCaptionPriceBack
            : pricing.szivoldalCaptionPrice
        }
      } else if (
        billablesLargeSide <= printAreaA4LargeSide &&
        billablesSmallSide <= printAreaA4SmallSide
      ) {
        if (hasGraphic) {
          return isBack && isThereFrontContent && pricing.a4GraphicPriceBack > 0
            ? pricing.a4GraphicPriceBack
            : pricing.a4GraphicPrice
        } else {
          return isBack && isThereFrontContent && pricing.a4CaptionPriceBack > 0
            ? pricing.a4CaptionPriceBack
            : pricing.a4CaptionPrice
        }
      } else {
        if (hasGraphic) {
          return isBack && isThereFrontContent && pricing.a3GraphicPriceBack > 0
            ? pricing.a3GraphicPriceBack
            : pricing.a3GraphicPrice
        } else {
          return isBack && isThereFrontContent && pricing.a3CaptionPriceBack > 0
            ? pricing.a3CaptionPriceBack
            : pricing.a3CaptionPrice
        }
      }
    }
  }
}
